import React from 'react';

// Types
import { MetricSlugs } from '../../ManagerDashboardData.constants';

// Components
import MetricsWrapper from '../MetricsWrapper';
import PieChart from 'Shared/components/charts/PieChart';
import WpAlert from 'Wpds/components/alert/WpAlert';

// Styles
import './TimeInMeetings.scss';

type Props = {
  meetingTimeData;
};

const TimeInMeetings = ({ meetingTimeData }: Props) => {
  const baseClassName = 'TimeInMeetings';

  return (
    <MetricsWrapper slug={MetricSlugs.time_in_meetings}>
      {!meetingTimeData.chart ? (
        <>
          No calendar data found. <a href="/user/integrations">Connect your calendar</a> to see how much time you spend
          in meetings.
        </>
      ) : (
        <>
          <div className={`${baseClassName}__chart`}>
            <PieChart
              datasets={meetingTimeData.chart.datasets}
              labels={meetingTimeData.chart.labels}
              options={meetingTimeData.chart.options}
              height={200}
            />
          </div>
          <div className={`${baseClassName}__note`}>
            <WpAlert showIcon={false} type="note">
              Time spent in meetings per week <h5>{meetingTimeData.total_time} hours</h5>
            </WpAlert>
          </div>
        </>
      )}
    </MetricsWrapper>
  );
};

export default TimeInMeetings;
